var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "chart-base",
    {
      ref: "chartbase",
      staticClass: "v-chart-line",
      attrs: {
        isOffset: _vm.isOffset,
        title: _vm.title,
        comment: _vm.comment,
        height: _vm.height,
        width: _vm.width,
        series: _vm.series,
        categories: _vm.categories,
        legend: _vm.legend,
      },
      on: { change: _vm.refresh },
      nativeOn: {
        mousemove: function ($event) {
          return _vm.hover.apply(null, arguments)
        },
        mouseleave: function ($event) {
          return _vm.leave.apply(null, arguments)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "tip",
          fn: function () {
            return [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showTip && _vm.tipIndex > -1
                  ? _c(
                      "div",
                      { staticClass: "v-chart__tip", style: _vm.tipStyle },
                      [
                        _vm.tipText
                          ? _c("div", [_vm._v(_vm._s(_vm.tipText))])
                          : _vm._e(),
                        _c("div", [
                          _vm._v(_vm._s(_vm.categories[_vm.tipIndex])),
                        ]),
                        _vm._l(_vm.hoverPoints, function (item, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "v-chart__tip__data" },
                            [
                              _c("i", {
                                staticClass: "v-chart__tip__data__point",
                                style: {
                                  background: _vm.legendColor[item.legend],
                                },
                              }),
                              _c("span", [_vm._v(_vm._s(item.data))]),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._l(_vm.lineList, function (t, i) {
        return _c(
          "g",
          { key: i, attrs: { name: t.legend } },
          [
            _c("path", {
              attrs: {
                d: t.d,
                stroke: _vm.legendColor[t.legend],
                "stroke-width": "1.5",
                fill: "none",
              },
            }),
            _vm.showPoint && _vm.animatePercent === 1
              ? _vm._l(_vm.points[i], function (circle) {
                  return _c("circle", {
                    key: circle.x,
                    attrs: {
                      cx: circle.x,
                      cy: circle.y,
                      r: "2",
                      fill: _vm.legendColor[t.legend],
                    },
                  })
                })
              : _vm._e(),
          ],
          2
        )
      }),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.tipIndex > -1
          ? _c(
              "g",
              [
                _c("line", {
                  attrs: {
                    x1: _vm.hoverX,
                    y1: _vm.axis.yStart,
                    x2: _vm.hoverX,
                    y2: _vm.axis.yEnd,
                    "stroke-width": "1",
                    stroke: "#838383",
                    "shape-rendering": "crispEdges",
                    "stroke-dasharray": "0",
                  },
                }),
                _vm._l(_vm.hoverPoints, function (circle, i) {
                  return _c("circle", {
                    key: i,
                    attrs: {
                      cx: circle.x,
                      cy: circle.y,
                      r: "3.5",
                      "stroke-width": "2",
                      stroke: "#fff",
                      fill: _vm.legendColor[circle.legend],
                    },
                  })
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }